import { XClose } from "@untitledui/icons";
import React from "react";
import { useTranslation } from "react-i18next";

interface ProfileModalProps {
  open: boolean;
  onClose: () => void;
  profile: {
    displayName: string;
    email: string;
    organization?: string;
    role?: string;
  } | null;
}

export const ProfileModal: React.FC<ProfileModalProps> = ({ open, onClose, profile }) => {
  const { t } = useTranslation();

  if (!open || !profile) return null;

  return (
    <div className="fixed inset-0 z-[1200] flex justify-end bg-black/30">
      {/*  PANEL */}
      <div className="w-[420px] max-w-[95vw] h-full shadow-xl border-l border-[var(--border-color)] bg-[var(--panel-bg)] transition-colors duration-500">
        {/*  HEADER */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-[var(--border-color)]">
          <div>
            <div className="text-md font-semibold text-[var(--text-primary)]">
              {t("viewProfile.header", { defaultValue: "Profile Settings" })}
            </div>
            <div className="text-xs text-[var(--text-primary)]">
              {t("viewProfile.subtitle", {
                defaultValue: "Manage your personal information and account details",
              })}
            </div>
          </div>

          <button onClick={onClose} className="p-1 rounded-md hover:bg-[var(--bg-surface)]">
            <XClose className="h-5 w-5 text-[var(--text-primary)]" />
          </button>
        </div>

        {/*  CONTENT */}
        <div className="p-5 space-y-6 text-sm">
          {/*  SECTION TITLE */}
          <div>
            <div className="text-md font-semibold text-[var(--text-primary)] mb-4">
              {t("viewProfile.information", { defaultValue: "Personal Information" })}
            </div>

            {/*  INITIALS ONLY (NO IMAGE) */}
            {/* <div className="mb-6">
              <div className="h-16 w-16 rounded-full bg-orange-500 flex items-center justify-center text-white text-sm font-bold">
                {getInitials(profile.displayName)}
              </div>
            </div> */}

            {/*  FIELDS */}
            <div className="space-y-4">
              <Input
                label={t("viewProfile.name", { defaultValue: "Name" })}
                value={profile.displayName}
              />
              <Input
                label={t("viewProfile.email", { defaultValue: "Email" })}
                value={profile.email}
              />
              <Input
                label={t("viewProfile.organization", { defaultValue: "Organization" })}
                value={profile.organization}
              />
              <Input label={t("viewProfile.role", { defaultValue: "Role" })} value={profile.role} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/*  INPUT */
const Input = ({ label, value }: { label: string; value?: string }) => (
  <div>
    <label className="block mb-1 text-xs font-medium text-[var(--text-primary)]">{label}</label>
    <input
      readOnly
      value={value || ""}
      className="w-full rounded-md border border-[var(--border-color)] bg-[var(--bg-surface)] px-3 py-2 text-sm text-[var(--text-primary)] focus:outline-none"
    />
  </div>
);
